import {observer} from "mobx-react";
import React from "react";
import {PsoAgreementsComponent} from "../common/pso-agreements.component";
import {
    IPsoFamilyAgreementsViewModel
} from "../../../../services/booking/models/pso/agreements/families/pso-family-agreements.view-model.interface";
import {
    IPsoFamilyAgreementFormFields, IPsoFamilyAgreementViewModel
} from "../../../../services/booking/models/pso/agreements/families/pso-family-agreement.view-model.interface";


interface PsoFamilyAgreementsComponentProps {

    familyAgreements: IPsoFamilyAgreementsViewModel;
}

export const PsoFamilyAgreementsComponent = observer((props: PsoFamilyAgreementsComponentProps) => {


    const AgreementsComponent = PsoAgreementsComponent<IPsoFamilyAgreementFormFields, IPsoFamilyAgreementViewModel, IPsoFamilyAgreementsViewModel>;

    const  renderHeader = () => {
        return (
            <>

            </>
        );
    }

    return (
        <AgreementsComponent psoAgreements={props.familyAgreements} renderHeader={renderHeader}>


        </AgreementsComponent>
    )
});